import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { tutorialRequest, tutorialSuccess, tutorialFailure } from '../reducers/tutorial';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/tutorial`;

function* tutorialAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?platform=web`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerTutorialSaga() {
  try {
    const response = yield call(tutorialAxios);
    const responseFromTutorial = response.data;

    yield put(tutorialSuccess(responseFromTutorial));
    if (response.status === 500) {
      yield put(tutorialFailure(responseFromTutorial));
    }
  } catch (error) {
    yield put(tutorialFailure(error));
  }
}

export function* watcherTutorialSaga() {
  yield takeLatest(tutorialRequest().type, workerTutorialSaga);
}
